<template>
  <p className="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
        className="ml-25"
        href=""
        target="_blank"
        rel="nofollow"
      >Medinet</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>


    <span class="float-md-right d-none d-md-block">Designed with Servident S.A
    </span>

    <span class="float-md-right d-none d-md-block mx-3">Last update: {{ lastUpdate }}</span>

  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { LAST_UPDATE } from '../../../assets/utils/infoApp';

export default {
  components: {
    BLink,
  },

  data() {
    return {
      lastUpdate: LAST_UPDATE
    }
  }
}
</script>
<style>
footer.footer span svg {
  margin-left: 0 !important;
}
</style>
